import React, { FC } from 'react'
import { IconBaseProps } from 'react-icon-base'
import { StyledIcon } from '.'

export const CsHelpCircledIcon: FC<IconBaseProps> = (props) => (
  <StyledIcon viewBox="0 0 1024 1024" {...props}>
    <g>
      <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm40.4 653.4c-1 35.6-27.4 57.6-61.6 56.6-32.8-1-58.6-24.4-57.6-60.2 1-35.6 28.2-58.2 61-57.2 34.4 1 59.4 25.2 58.2 60.8zm97.4-254.6c-8.4 11.8-27.2 27-50.8 45.4l-26.2 18c-12.8 9.8-20.8 21.4-25 34.6-2.2 7-3.8 25.2-4.2 37.4-.2 2.4-1.6 7.8-9 7.8h-78.2c-8.2 0-9.2-4.8-9-7.2 1.2-33.2 6-60.6 19.8-82.6 18.6-29.6 71-60.8 71-60.8 8-6 14.2-12.4 19-19.4 8.8-12 16-25.4 16-39.8 0-16.6-4-32.4-14.6-45.6-12.4-15.4-25.8-22.8-51.6-22.8-25.4 0-40.2 12.8-50.8 29.6s-8.8 36.6-8.8 54.6H350c0-68 17.8-111.4 55.4-137 25.4-17.4 57.8-25 95.6-25 49.6 0 89 9.2 123.8 35.6C657 310 674 344.4 674 390.8c0 28.6-10 52.6-24.2 72z" />
    </g>
  </StyledIcon>
)

CsHelpCircledIcon.displayName = 'CsHelpCircledIcon'
